import React, { memo } from "react";
import clsx from "clsx";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import styles from "./Header.module.scss";
import { CarConfigStep } from "../../../../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { useAphNavigation } from "../../../../hooks/useAphNavigation";
import { CarConfigLabel, useCarConfigLabel } from "../../../../utils/labelUtils";
import { useCarConfigSelector } from "../../../../redux/store";

type NavigationType = {
    activeStep: CarConfigStep;
};
const Navigation = (props: NavigationType): JSX.Element => {
    const { activeStep } = props;
    const loadedStepUrls = useCarConfigSelector((state) => state.carConfigSettings.loadedStepUrls);
    const apheleiaHighlightsPageUrl = useCarConfigSelector(
        (state) => state.carConfigSettings.apheleiaHighlightsPageUrl,
    );
    const [configureLabel, specsLabel, highlightsLabel] = useCarConfigLabel([
        "carConfigConfigure",
        "carConfigSpecs",
        "carConfigHighlights",
    ]);

    const handleClick = useAphNavigation();
    const navigationLabel = useCarConfigLabel("carConfigA11yNavPanelNavigation");

    return (
        <nav className={styles.navigation} aria-label={navigationLabel}>
            <ul role="list">
                <li>
                    <Button
                        variant="clean"
                        href={loadedStepUrls?.configure}
                        title={configureLabel}
                        className={clsx(styles["nav-link"], activeStep === CarConfigStep.Configure && styles.active)}
                        onClick={handleClick(CarConfigStep.Configure)}
                        aria-controls="tab-configure"
                        aria-expanded={activeStep === CarConfigStep.Configure}
                    >
                        <CarConfigLabel label="carConfigConfigure" />
                    </Button>
                </li>
                <li>
                    <Button
                        variant="clean"
                        href={loadedStepUrls?.specs}
                        title={specsLabel}
                        className={clsx(styles["nav-link"], activeStep === CarConfigStep.Specs && styles.active)}
                        onClick={handleClick(CarConfigStep.Specs)}
                        aria-controls="tab-specs"
                        aria-expanded={activeStep === CarConfigStep.Specs}
                    >
                        <CarConfigLabel label="carConfigSpecs" />
                    </Button>
                </li>
                {apheleiaHighlightsPageUrl && (
                    <li>
                        <Button
                            variant="clean"
                            href={loadedStepUrls?.highlights}
                            title={highlightsLabel}
                            className={clsx(
                                styles["nav-link"],
                                activeStep === CarConfigStep.Highlights && styles.active,
                            )}
                            onClick={handleClick(CarConfigStep.Highlights)}
                            aria-controls="tab-highlights"
                            aria-expanded={activeStep === CarConfigStep.Highlights}
                        >
                            <CarConfigLabel label="carConfigHighlights" />
                        </Button>
                    </li>
                )}
            </ul>
        </nav>
    );
};

export default memo(Navigation);
